var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapCrosshair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#47525e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6,37.7c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3S62,56.8,62,50S56.4,37.7,49.6,37.7z M49.6,58.7  c-4.8,0-8.7-3.9-8.7-8.7s3.9-8.7,8.7-8.7s8.7,3.9,8.7,8.7S54.4,58.7,49.6,58.7z M87.3,48.2h-5.5c-0.9-16.3-14.1-29.5-30.4-30.4v-5.6  c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8v5.6c-16.3,1-29.3,14.1-30.3,30.3h-5.7c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h5.7  c0.9,16.3,14,29.4,30.3,30.3v5.6c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8v-5.6c16.4-0.9,29.5-14,30.4-30.4h5.5c1,0,1.8-0.8,1.8-1.8  S88.3,48.2,87.3,48.2z M51.4,78.5v-5.6c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8v5.6c-14.2-1-25.6-12.4-26.6-26.6h5.5  c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8h-5.5c0.9-14.2,12.3-25.7,26.6-26.6v5.6c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8v-5.6  c14.3,0.9,25.8,12.3,26.7,26.6h-5.7c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h5.7C77.2,66.2,65.7,77.6,51.4,78.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapCrosshair);
export default __webpack_public_path__ + "static/media/map_crosshair.2fbdff77.svg";
export { ForwardRef as ReactComponent };